package com.merkost.handpass.api.dto.listing

import com.merkost.handpass.api.enums.CategoryIcon
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CategoryResponse(
    val id: String,
    @SerialName("parent_id") val parentId: String? = null,
    val name: String,
    val slug: String,
    val description: String? = null,
    @SerialName("icon_url") val iconUrl: String? = null,
    @SerialName("icon_enum") val iconEnum: CategoryIcon? = null,
    @SerialName("cover_image_url") val coverImageUrl: String? = null,
    val level: Int = 0,
    @SerialName("display_order") val displayOrder: Int = 0,
    @SerialName("is_active") val isActive: Boolean = true,
    @SerialName("listing_count") val listingCount: Int = 0,
    val children: List<CategoryResponse>? = null
)

@Serializable
data class CategoryAttributeResponse(
    val id: String,
    @SerialName("category_id") val categoryId: String,
    val name: String,
    val type: String,
    val required: Boolean = false,
    val options: List<String> = emptyList(),
    @SerialName("display_order") val displayOrder: Int = 0
)
